import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth, useProfile } from '@/hooks';

export default function LogoutView() {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();
  const { profile } = useProfile();
  const navigate = useNavigate();
  useEffect(() => {
    logout();
    gtag('event', 'logout', { user: profile.id });
    setTimeout(() => {
      navigate('/login');
    }, 1000);
  }, []);

  return (
    <div className='flex flex-col py-8 mx-auto w-80 text-sm'>
      <h1 className='text-xl font-bold mb-6 text-center'>{t('Logout')}</h1>
      {isAuthenticated ? (
        <p className='text-center'>{t('Hold on, we are clear your session...')}</p>
      ) : (
        <>
          <p className='text-center'>{t('Sorry to see you go :(')}</p>
          <hr className='my-4 border-t' />
          <p className='text-center'>
            {t('Don`t have an account yet?')}{' '}
            <Link to='/login' className='font-bold'>
              {t('Login')}
            </Link>
          </p>
        </>
      )}
    </div>
  );
}
